import { TinyColor } from '@ctrl/tinycolor'

import { getMatchingPathPattern } from './utility'

const SVG_DOTS_ICON = (color) =>
    `<svg class="dots" width="25" height="20" style="vertical-align: middle; fill: #ffffff;"><circle cx="2.5" cy="10" r="2.5" style="transform-origin: 2.5px 10px;"></circle><circle cx="12.5" cy="10" r="2.5" style="transform-origin: 12.5px 10px;"></circle><circle cx="22.5" cy="10" r="2.5" style="transform-origin: 22.5px 10px;"></circle></svg>`

function computeBestTextColorFor(backgroundColor: string): string {
    const color = new TinyColor(backgroundColor)

    if (color.getBrightness() > 180) {
        return '#000000'
    }

    if (color.getAlpha() < 0.4) {
        return '#000000'
    }

    return '#ffffff'
}

export function initializeButtonListeners() {
    if ('/subscriptions' === getMatchingPathPattern()) {
        const forms = document.getElementsByTagName('form')
        for (const form of forms) {
            const buttons = form.getElementsByTagName('button')

            if (buttons.length > 0) {
                const button = buttons[0]
                form.addEventListener('submit', (e) => {
                    e.preventDefault()
                    form.submit()
                    setButtonLoadingState(button, true)
                    for (const inputElement of form.querySelectorAll('input')) {
                        inputElement.disabled = true
                    }
                })
            }
        }
    }
}

export function setInputState(parent: HTMLElement, tagName: 'input' | 'textarea', disabled: boolean) {
    for (const element of parent.getElementsByTagName(tagName)) {
        if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
            element.disabled = disabled
        }
    }
}

export function setButtonLoadingState(button: HTMLButtonElement, loading: boolean) {
    button.disabled = loading

    if (loading) {
        button.setAttribute('data-label', button.innerText)
        button.setAttribute('data-width', button.style.width)
        button.style.width = getComputedStyle(button).width
        button.innerHTML = SVG_DOTS_ICON(computeBestTextColorFor(window.noticeable.accentColor))
    } else {
        const elements = button.getElementsByClassName('dots')
        for (const element of elements) {
            element.remove()
        }
        button.innerHTML = button.getAttribute('data-label') ?? 'Continue'
        button.style.width = button.getAttribute('data-width') ?? 'auto'
    }

    return true
}
